import { Component, Input, OnInit } from '@angular/core';

import { AppData } from '../../services/appdata.service';
import { Global } from '../../services/global.service';
import { API } from '../../services/api.service';

import { Config } from 'src/app/models/env-vars.model';


import * as bootstrap from 'bootstrap';
// import * as $ from 'jquery';
import 'moment-timezone';
import * as moment from 'moment';

@Component({
  selector: 'app-purchase-certificates',
  templateUrl: './purchase-certificates.component.html',
  styleUrls: ['./purchase-certificates.component.css']
})
export class PurchaseCertificatesComponent implements OnInit
{
	config = Config;
	type: string = this.global.getURLFromParam('type');
	label: string = this.global.getURLFromParam('label');
	selected_area_unit: string = '';
	selected_volume_unit: string = '';
	selected_weight_unit: string = '';
	selected_distance_unit: string = '';
	title: string = '';
	selected_energy_unit: string = '';
	reporting_period: string = '';
	expiry_date: string = '';
	total_errors: number = 0;
	loading: boolean = false;
	received_data_for_all: boolean = false;
	show_cert: boolean = false;
	data_coverage: any = {
		"performance": {},
		"improvement": {}
	};
	reportingDate: any = moment(new Date()).format("MMM DD, YYYY");
	score_data: any = {};
	improvement_data: any = {};
	user_preference: any = {};

	energy_unit: any = {
		"kbtu": "kBTU",
		"kwh": "kWh",
	};
	area_unit: any = {
		"sqft": "sq. feet",
		"sqm": "sq. meter",
	};
	volume_unit: any = {
		"gal": "gal",
		"l": "liter",
	};
	weight_unit: any = {
		"lbs": "lbs",
		"kg": "kgs",
	};
	distance_unit: any = {
		"miles": "miles",
		"km": "km",
	};
	picker_loaded: boolean = false;
	styles: any = '<style class="ng-scope">\n    @font-face \n    {\n        src: url(https://api.usgbc.org/arc/static/fonts/GOTHIC.TTF?subscription-key=5a41833022f046dc951383ead38d16d3);\n        font-family: Gothic;\n    }\n    @font-face \n    {\n        src: url(https://api.usgbc.org/arc/static/fonts/GOTHICB.TTF?subscription-key=5a41833022f046dc951383ead38d16d3);\n        font-family: GothicBold;\n    }\n    #myCanvas\n    {\n        font-family: Gothic;\n        background-color: #F4F5F8 !important;\n    }\n    #myCanvas .cert_appLogo\n    {\n        background: url(' + this.config.config.settings.s3_bucket_url + '/assets/images/arc-logo-white.png) no-repeat;\n        background-size: contain;\n        height: 80px;\n        margin-top: 125px;\n        background-position: 50%;\n    }\n    .certificate\n    {\n        margin: 35px auto;\n        width: 11in;\n        height: 8.5in;\n        background-color: white;\n        display: flex;\n    }\n    #myCanvas #cert_banner\n    {\n        width: 25%;\n        /* float: left; */\n        /* height: 100%; */\n    }\n    #myCanvas #cert_content\n    {\n        width: 75%;\n        text-align: center;\n        background-color: white;\n        /* float: left; */\n        /* height: 100%; */\n        position: relative;\n    }\n    #myCanvas .mb5\n    {\n        margin-bottom: 2px !important;\n    }\n    #myCanvas .heading1\n    {\n        margin-top: 40px;\n        margin-bottom: 40px;\n        font-size: 10pt;\n        color: rgb(117, 129, 138);\n        font-family: Gothic;\n        font-weight: 600;\n    }\n    #myCanvas .heading2\n    {\n        margin-bottom: 15px;\n        font-size: 10pt;\n        color: rgb(117, 129, 138);\n    }\n    #myCanvas .heading3\n    {\n        margin-bottom: 15px;\n        font-size: 10pt;\n        line-height: 25px;\n    }\n    #myCanvas #project_name\n    {\n        font-family: GothicBold;\n        font-size: 24pt;\n        font-weight: normal;\n        margin: 0px;\n    }\n    #myCanvas #project_address\n    {\n        font-family: Gothic;\n        font-weight: 600;\n        font-size: 10pt;\n        margin-top: 10px;\n        margin-bottom: 20px;\n    }\n    #myCanvas .category\n    {\n        font-family: Gothic;\n        font-weight: 600;\n        padding: 0px 0px 20px 0px;\n        margin: 0px 50px;\n        border-bottom: 1px solid rgb(220, 225, 226);\n        margin-bottom: 20px;\n        font-size: 16pt;\n    }\n    #myCanvas .metrics\n    {\n        overflow: auto;\n        margin: 0px 50px;\n        border-bottom: 1px solid rgb(220, 225, 226);\n        padding-bottom: 45px;\n        margin-bottom: 20px;\n        display: flex;\n    }\n    #myCanvas .metrics .heading\n    {\n        color: rgb(117, 129, 138);\n        font-size: 10pt;\n        font-family: Gothic;\n        font-weight: 600;\n        margin-bottom: 10px;\n    }\n    #myCanvas .cert_block\n    {\n        height: 5px;\n        width: 30px;\n        margin-bottom: 10px;\n    }\n    #myCanvas .value\n    {\n        font-family: GothicBold;\n        font-weight: normal;\n        margin: 0px;\n        color: rgb(117, 129, 138);\n        text-align: left;\n        font-size: 27px;\n    }\n    #myCanvas .value span, #myCanvas .cert_bold\n    {\n        color: black;\n        font-family: Gothic;\n        font-weight: 600;\n    }\n    #myCanvas .data\n    {\n        font-size: 10pt;\n        overflow: auto;\n        line-height: 18pt;\n        color: rgb(117, 129, 138);\n        position: relative;\n    }\n    #myCanvas .left\n    {\n        \n    }\n    #myCanvas .right\n    {\n        position: absolute;\n        right: 0px;\n    }\n    #myCanvas .mb27\n    {\n        margin-bottom: 27px;\n    }\n    #myCanvas .heading4\n    {\n        margin-bottom: 15px;\n        font-size: 9px;\n        font-family: Gothic;\n        font-weight: 600;\n    }\n    #myCanvas .mb0\n    {\n        margin-bottom: 0px;\n    }\n    #myCanvas .signature\n    {\n        background: url(' + this.config.config.settings.s3_bucket_url + '/assets/images/sig.png) no-repeat;\n        background-size: contain;\n        background-position: 55%;\n        height: 45px;\n        border-bottom: 1px solid rgb(220, 225, 226);\n        margin: 0px 115px;\n        margin-top: 25px;\n        margin-bottom: 10px;\n    }\n    #myCanvas .cert_grey\n    {\n        color: rgb(117, 129, 138);\n    }\n    #myCanvas .key_metrics\n    {\n        width: 55%;\n        text-align: left;\n        /* float: left; */\n    }\n    .main_score\n    {\n        width: 45%;\n        text-align: left;\n        /* float: left; */\n    }\n    .rt10\n    {\n        position: relative;\n        top: 30px;\n    }\n    .footer\n    {\n        position: absolute;\n        bottom: 40px;\n        width: 100%;\n    }\n    .bold\n    {\n        font-weight: bold;\n    }\n    .energy_banner_gradient\n    {\n        background: linear-gradient(to bottom left, #273c40 0%, #375e76 100%);\n    }\n    .waste_banner_gradient\n    {\n        background: linear-gradient(to bottom left, #275d8d 0%, #4cb0db 100%);\n    }\n</style>';

	constructor(
		public global: Global,
		public appData: AppData,
		private api: API,
		private modal: NgbModal
	)
	{}

	ngOnInit(): void
	{
		this.getDataCoverage(this.type);
	}

	goBack()
	{
		if(this.show_cert)
		{
			this.toggleCertiView();
			return;
		}
		if(this.type == 'climaterisk')
		{
			this.global.goToApp("selected_project", 
			{
				"leed_id": this.appData.get('leed_id'),
				"app_name": "climate-risk"
			});
		}
		else
		{
			this.global.goToApp("selected_project", 
			{
				"leed_id": this.appData.get('leed_id'),
				"app_name": "performance-certificates"
			});
		}
	}

	resetDate()
	{
		this.reportingDate = moment(new Date()).format("MMM DD, YYYY");
		$('#reportingDate').val(this.reportingDate);
		this.getDataCoverage(this.type, this.reportingDate);
	}

	submit()
	{
		if(this.data_coverage.validation && this.data_coverage.coverage_flag == 'green')
		{
			this.saveCertificate();
		}
		else
		{
			this.showWarning(this.type);
		}
	}

	toggleCertiView()
	{
		this.show_cert = !this.show_cert;
		if(this.show_cert)
		{
			this.initCert();
		}
		else
		{
			$('#content').css('background-color', "white")
		}
	}

	getDataCoverage(category: string, at?: string)
	{
		this.loading = true;
		this.received_data_for_all = false;
		if(category == 'climaterisk')
		{
			var urls = [
				'/assets/LEED:' + this.appData.get('leed_id') + '/scores/recompute/', 
				'/assets/LEED:' + this.appData.get('leed_id') + '/datavalidate/electricity/'
			];
			urls[0] += "?at=" + moment(at).format('YYYY-MM-DD');
			urls[1] += "?at=" + moment(at).format('YYYY-MM-DD');
			this.api.async(urls).subscribe(data =>
			{
				this.loading = false;
				this.received_data_for_all = true;
				this.score_data = data[0];
				this.data_coverage = data[1];
				
				if(this.data_coverage.performance == undefined)
				{
					this.data_coverage.performance = {};
				}
				if(this.data_coverage.percentage == null)
				{
					this.data_coverage.coverage_flag = 'red';
				}
				this.data_coverage.performance["score"] = this.score_data.subscores_carbon;
				this.initCert();

				var total_errors = 0;
				if(this.data_coverage.coverage_flag == 'red')
				{
					total_errors += 1;
				}
				if(!this.data_coverage.validation)
				{
					total_errors += 1;
				}
				this.total_errors = total_errors;
			}, error =>
			{
				this.loading = false;
				this.received_data_for_all = false;
			});
		}
		else
		{
			var urls = [
				'/assets/LEED:' + this.appData.get('leed_id') + '/datavalidate/'+category.replace("_", "") + "/", 
				'/assets/LEED:' + this.appData.get('leed_id') + '/scores/recompute/', 
				'/assets/LEED:' + this.appData.get('leed_id') + '/scores/improvement/recompute/',
				'/auth/user/preference/'
			];
			if(at == undefined)
			{
				urls[0] += "?at=" + moment(new Date()).format('YYYY-MM-DD');
				urls[2] += "?category=" + category;
			}
			else
			{
				urls[0] += "?at=" + moment(at).format('YYYY-MM-DD');
				urls[1] += "?at=" + moment(at).format('YYYY-MM-DD');
				urls[2] += "?at=" + moment(at).format('YYYY-MM-DD') + "&category=" + category;
			}

			this.api.async(urls).subscribe(data =>
			{
				this.loading = false;
				this.received_data_for_all = true;
				this.data_coverage = data[0];
				this.score_data = data[1];
				this.improvement_data = data[2];
				try
				{
					this.user_preference = data[3][0];
				}
				catch(e)
				{
					this.user_preference = {
						"gfa_unit": "sqft",
						"electricity_unit": "kbtu",
						"water_unit": "gal",
						"waste_unit": "lbs",
						"transport_unit": "miles"
					};
				}
				
				this.selected_energy_unit = this.energy_unit[this.user_preference.electricity_unit];
				this.selected_area_unit = this.area_unit[this.user_preference.gfa_unit];
				this.selected_volume_unit = this.volume_unit[this.user_preference.water_unit];
				this.selected_weight_unit = this.weight_unit[this.user_preference.waste_unit];
				this.selected_distance_unit = this.distance_unit[this.user_preference.transport_unit];

				if(category == 'transportation')
				{
					this.data_coverage.performance["score"] = this.score_data["transport"];
				}
				else
				{
					this.data_coverage.performance["score"] = this.score_data[category];
				}
				this.data_coverage.improvement["score"] = this.improvement_data[category].score;
				if(this.data_coverage.improvement["score"] == 'None')
				{
					this.data_coverage.improvement["score"] = null;
				}
				this.initCert();

				var total_errors = 0;
				if(this.data_coverage.coverage_flag == 'red')
				{
					total_errors += 1;
				}
				if(!this.data_coverage.validation)
				{
					total_errors += 1;
				}
				this.total_errors = total_errors;
			}, error =>
			{
				this.loading = false;
				this.received_data_for_all = false;
			});
		}
	}

	initDatePicker(field: string)
	{
		if(this.picker_loaded == false)
		{
			this.picker_loaded = true;
			var lastYearDate = new Date();
			lastYearDate.setFullYear(lastYearDate.getFullYear() - 2);
			(<any>$('#' + field)).fdatepicker(
			{
				format: $('#' + field).attr('max'),
				onRender: function(date: Date)
				{
					return date.valueOf() > new Date().valueOf() || lastYearDate.valueOf() > date.valueOf() ? 'disabled' : '';
				}
			}).on('changeDate', (ev: any) =>
			{
				this.reportingDate = moment($('#reportingDate').val()).format("MMM DD, YYYY");
				this.getDataCoverage(this.type, moment(this.reportingDate).format('YYYY-MM-DD'))
			});
		}
	}

	initCert()
	{
		$('#content').css('background-color', "#F4F5F8");
		this.reporting_period = moment($('#reportingDate').val()).subtract(1, 'year').add(1, 'day').format("MMM DD, YYYY") + " - " + $('#reportingDate').val();
		this.expiry_date = moment(new Date()).add(1, 'year').format("MMM DD, YYYY");
		let energy_color = "#253a3d"
		let water_color = "#54caf5"
		let waste_color = "#231f20"
		let transport_color = "#37607a"
		let human_color = "#174173"
		let climate_color = '#2A428A';
		var selected_color = '';
		if(this.type == 'energy')
		{
			this.title = 'Energy & Emissions';
			selected_color = energy_color;
		}
		else if(this.type == 'water')
		{
			this.title = 'Water Usage';
			selected_color = water_color;
		}
		else if(this.type == 'waste')
		{
			this.title = 'Waste Generated/Diverted';
			selected_color = waste_color;
		}
		else if(this.type == 'transportation')
		{
			this.title = 'Transportation';
			selected_color = transport_color;
		}
		else if(this.type == 'human_experience')
		{
			this.title = 'Human Experience';
			selected_color = human_color;
		}
		else if(this.type == 'climaterisk')
		{
			this.title = 'Climate Risk';
			selected_color = climate_color;
		}

		let items = <any>document.getElementsByClassName('cert_block');
		for(let i = 0; i < items.length; i++)
		{
			items[i].style.backgroundColor = selected_color;
		}

		if(this.type != 'energy' && this.type != 'waste')
		{
			items = document.getElementsByClassName('cert_banner');
			for(let i = 0; i < items.length; i++)
			{
				items[i].style.backgroundColor = selected_color;
			}	
		}
	}

	saveCertificate()
	{
		let credit_id = '';
		if(this.type == 'energy')
		{
			credit_id = 'PF901';
		}
		else if(this.type == 'water')
		{
			credit_id = 'PF902';
		}
		else if(this.type == 'waste')
		{
			credit_id = 'PF903';
		}
		else if(this.type == 'transportation')
		{
			credit_id = 'PF904';
		}
		else
		{
			credit_id = 'PF905';
		}

		let data_validation = 'Not Valid';
		let data_completion = this.data_coverage.percentage;

		if (this.data_coverage.validation){
			data_validation = 'Acceptable';
		}

		let all_test_passed = false;
		if(this.data_coverage.validation && this.data_coverage.coverage_flag == 'green')
		{
			all_test_passed = true;
		}

		let html_id:string, url:string, payload: any;
		if(this.type == 'climaterisk')
		{
			html_id = "certificate_score";
			url = '/assets/LEED:' + this.appData.get('leed_id') + '/certifications/climaterisk/';
			payload = {
				"type": "Climate Risk Certification",
				"certification_level": "Climate Risk",
				"certification_type": "Climate Risk Certification",
				"review_start_date": moment($('#reportingDate').val()).subtract(1, 'year').add(1, 'day').format("YYYY-MM-DD"),
				"review_expiry_date": moment($('#reportingDate').val()).format("YYYY-MM-DD"),
				"electrification_score": this.data_coverage.electrification,
				"score_submitted": this.global.formatNumber(this.data_coverage.carbon, 0),
				"base_score": this.global.formatNumber(this.appData.get('buildingData').base_score, 0, false),
				"target_score": this.global.formatNumber(this.data_coverage.carbon, 0),
				"target_level": "Not applicable",
				"status": "completed",
				"all_test_passed": all_test_passed,
				"certification_points": this.global.formatNumber(this.data_coverage.carbon, 0),
				"date_certified": moment($('#reportingDate').val()).format("YYYY-MM-DD")
			}
		}
		else
		{
			html_id = "certificate_final";
			url = '/assets/LEED:' + this.appData.get('leed_id') + '/certifications/performance/';
			payload = {
				"type": "Performance Score Certification",
				"certification_level": "Arc " + this.label,
				"certification_type": "Performance Score Certification",
				"review_start_date": moment($('#reportingDate').val()).subtract(1, 'year').add(1, 'day').format("YYYY-MM-DD"),
				"review_expiry_date": moment($('#reportingDate').val()).format("YYYY-MM-DD"),
				"score_submitted": this.global.formatNumber(this.data_coverage.performance.score, 0, false),
				"improvement_score": this.global.formatNumber(this.data_coverage.improvement.score, 0, false),
				"credit_submitted": credit_id,
				"base_score": this.global.formatNumber(this.appData.get('buildingData').base_score, 0, false),
				"target_score": this.global.formatNumber(this.data_coverage.performance.score, 0, false),
				"target_level": "Not applicable",
				"status": "completed",
				"data_completion": data_completion,
				"data_validation": data_validation,
				// "document_count": this.data_coverage.documents,
				"document_count": 0,
				"all_test_passed": all_test_passed,
				"certification_points": this.global.formatNumber(this.data_coverage.performance.score, 0, false),
				"date_certified": moment($('#reportingDate').val()).format("YYYY-MM-DD")
			};
		}
		
		var form_data = new FormData();
		for (var key in payload)
		{
			form_data.append(key, payload[key]);
		}

		var mimeType = 'text/html';
		let html_content = this.styles + $('#' + html_id).html();
		if(this.global.getBrowser().ie == true || this.global.getBrowser().safari == true)
		{
			var file: any = new Blob([html_content], { type: mimeType});
			file.lastModifiedDate = new Date();
			form_data.append('file', file, "file.html");
		}
		else
		{
			var file: any = new File([html_content], "file.html", {type: mimeType, lastModified: <any>new Date()});
			form_data.append('file', file);
		}
		
		var custom_basic_config_header = 
		{
			headers: 
			{
				"responseType": "arraybuffer",
				"Ocp-Apim-Subscription-Key": this.config.sub_key,
				"Authorization": "Bearer " + this.appData.get('token')
			}
		};

		this.loading = true;
		this.api.post(url, form_data, custom_basic_config_header).subscribe(
			data =>
			{
				payload["document"] = data.certificate;
				payload["certification_expire"] = data.certification_expire;
				if(this.type == 'climaterisk')
				{
					this.global.goToApp("selected_project", 
					{
						"leed_id": this.appData.get('leed_id'),
						"app_name": "climate-risk"
					});
				}
				else
				{
					this.global.goToApp("selected_project", 
					{
						"leed_id": this.appData.get('leed_id'),
						"app_name": "performance-certificates",
						"payload": payload
					});
				}
				this.loading = false;
			},
			error =>
			{
				this.loading = false;
			}
		);
	}

	showWarning(type: any)
	{
		let modalRef = this.modal.open(ModalContent, { windowClass: 'certificate_modal' });
		modalRef.componentInstance.data_coverage = this.data_coverage;
		modalRef.componentInstance.parent_object = this;
	}

	openScoringFactorHelp()
	{
		let modalRef = this.modal.open(SidebarModalContent, { windowClass: 'sideBar--projectsDetailsModal factor_score' });
		modalRef.componentInstance.data_coverage = this.data_coverage;
		modalRef.componentInstance.total_errors = this.total_errors;
	}
}

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';  
@Component({
	selector: 'modal-content',
	standalone: true,
	templateUrl: '../../components/modal/templates/performance_certificate_warning.html',
	imports: [CommonModule],
})
class ModalContent implements OnInit
{
	autocase_modal = false;
	heading_title = 'Reporting period warning';
	message: string = '';
	type: string = '';
	error_json: any = {};
	@Input() data_coverage: any = {
		"performance": {},
		"improvement": {}
	};
	@Input() parent_object: any;

	constructor(
		public activeModal: NgbActiveModal,
		public global: Global,
		public appData: AppData,
	)
	{}

	ngOnInit(): void
	{
		if(this.data_coverage.performance.score == null)
		{
			this.message = "Your data for the selected reporting period failed our data check. Please go back and check your data and ensure that everything is correct.";
		}
		else
		{
			this.message = "Your data for the selected reporting period failed our data check. Please go back and check your data and ensure that everything is correct. If you have already validated your data and are sure that the data is correct, you can click proceed anyway.";
		}	
	}

	
	cancel()
	{
		this.activeModal.close('Close click');
	};

	goToDI()
	{
		if(this.type == 'human_experience')
		{
			this.type = 'human';
		}
		else if(this.type == 'transportation')
		{
			this.type = 'transport';
		}
		this.global.goToApp("selected_project", 
		{
			"leed_id": this.appData.get('leed_id'),
			"app_name": "data-input",
			"type": this.type
		});
		this.cancel();
	};
	
	submit()
	{
		this.parent_object.saveCertificate();
		this.cancel();
	};
	
	adjustPeriod()
	{
		(<any>$('#reportingDate')).fdatepicker('show');
		this.cancel();
	};
}

@Component({
	selector: 'modal-content',
	standalone: true,
	templateUrl: '../../components/modal/templates/helpbox/scoring_factors_correct.html',
	imports: [CommonModule],
})
class SidebarModalContent implements OnInit
{
	@Input() data_coverage: any = {
		"performance": {},
		"improvement": {}
	};
	@Input() total_errors: any;

	constructor(
		public activeModal: NgbActiveModal
	)
	{}

	ngOnInit(): void
	{
		
	}

	cancel()
	{
		this.activeModal.close('Close click');
	};
}